/**
 * The ChoiceLoader handels AJAX loaded content.
 * It uses links with anchors to load data from html sites.
 *
 * @module ChoiceLoader
 * @requires jQuery
 * @requires Velocity
 * @requires Velocity UI
 * @return {Object} public methods
 *
 */
const ChoiceLoader = (function() {

	/**
	 * Initializes this module.
	 */
	function init(){
		// Don't even bother when there is no choice-wrapper
		if (document.querySelector('#choice-wrapper') === null) return false;

		addListeners();
	}

	/**
	 * Sets up listeners for user actions.
	 */
	function addListeners(){
		$('a.choice, button.choice, area.choice').unbind("click");
		$('a.choice, button.choice, area.choice').on("click", loadNextPage);
	}

	/**
	 * This method handels the link click functionality and loads the content via ajax.
	 * To determine the links they must contain the "choice"-Class and a href with anchor tag as content-element id.
	 * @return {false}
	 */
	function loadNextPage(){
		var file = this.href;
		var choice = this.hash;
		var targetLink = $(this);
		$("<div>").load(file + " " + choice, function() {
		    $("#choice-wrapper").append($(this).find(choice).parent().html());
		    // delete steps after and removes is-active from links
		    deleteStepsAfter(choice);
		    // set active
		    targetLink.addClass('is-active');
		    // add listener to loaded html
		    addListeners();
		    // Activate JS Features
		    activateFeatures();
		    // Animate scroll
		    $("#choice-wrapper > div:last-child").velocity("scroll", { duration: 500, mobileHA: false });
		});
		return false;
	}

	/**
	 * This method deletes steps after
	 */
	function deleteStepsAfter(choiceWrapper){
		// get the index of the choice via choiceWrapper
		var index = parseInt(choiceWrapper.replace('#choice', ''));
		// remove is-active from current choice element
		$('#choice' + (index-1) + ' a.is-active').removeClass('is-active');
		// count all choice child elements
		var count = $('#choice-wrapper').children('.choice-content').length;
		// go threw the steps after click and remove them
		for(index; index < count; index++){
			$('#choice' + index).remove();
		}
	}

	/**
	 * Activates JS-Features / Modules
	 */
	function activateFeatures(){
		// trigger resize (resize is triggering some js-functions for slider etc)
		window.dispatchEvent(new Event('resize'));
		// Init Accordion (as ther might be some accordions)
		Accordion.init();
		/**
		 * User rwdImageMaps plugin for responsive maps
		 */
		if($('img[usemap]')){
			$('img[usemap]').rwdImageMaps();
		}
	}

	// Return public methods
	return {
		init: init
	};

})();

window.ChoiceLoader = ChoiceLoader;
export default ChoiceLoader;
